export default function Timeline({ items }) {
  return (
    <div className="su-timeline">
      {items.map((item, index) => (
        <div className="su-timeline-row" key={item.title}>
          <span className="su-timeline-when">{item.when}</span>
          <span className="su-timeline-rail">
            <i className={item.done ? "is-done" : ""} />
            {index < items.length - 1 ? <b className={item.done ? "is-done" : ""} /> : null}
          </span>
          <span className="su-timeline-copy">
            <strong>{item.title}</strong>
            <span>{item.body}</span>
          </span>
        </div>
      ))}
    </div>
  );
}
